/**
* @name: import-result-show
* @author: weiyong
* @date: 2024-01-17 21:51
* @description：import-result-show
* @update: 2024-01-17 21:51
*/
<template>
 <div style="padding: 12px;">

   <a-list item-layout="horizontal" size="small" :data-source="records">
     <template #renderItem="{ item }">
       <a-list-item>
         <a-list-item-meta>
           <template #title>
             <div class="w100b flex-div-bet">
               <div>
                 excel行号：{{item.rowNum}}
                 <span v-if="item.result==='导入失败'" style="color:#F72229;font-size:12px;">
                   {{item.msg}}
                 </span>
               </div>
               <div>
                 <a-tag v-if="item.result==='导入失败'" color="#F72229">{{item.result}}</a-tag>
                 <a-tag v-else color="#87d068">{{item.result}}</a-tag>
               </div>
             </div>
           </template>
         </a-list-item-meta>
       </a-list-item>
     </template>
   </a-list>
 </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "import-result-show",
});
</script>

<script lang="ts" setup>
import {Tag as ATag,List as AList,ListItem as AListItem,ListItemMeta as AListItemMeta} from 'ant-design-vue'
interface propsType{
  records:any,
}
const propsDef = withDefaults(defineProps<propsType>(),{
  records: {},
});
</script>

<style type="text/css" lang="less">

</style>
